/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

/**
 * Component imports.
 */
import { ProfileLeftComponent } from './profile-left/profile-left.component';
import { SuggestionRightComponent } from './suggestion-right/suggestion-right.component';
import { CommentTextComponent } from './product-comment/comment-text/comment-text.component';
import { ReplyCommentTextComponent } from './product-comment/reply-comment-text/reply-comment-text.component';
import { PageErrorReloadComponent } from './page-error-reload/page-error-reload.component';
import { CommonComponent } from './common.component';
import { VerifyProcessComponent } from './verify-process/verify-process.component';
import { PostProcessingComponent } from '../web/posting/post-processing/post-processing.component';
import { NotVerifiedComponent } from './verify-cards/not-verified/not-verified.component';
import { MapAssociationComponent } from './verify-cards/map-association/map-association.component';
import { VerificationUnderProcessComponent } from './verify-cards/verification-under-process/verification-under-process.component';
import { VerifiedComponent } from './verify-cards/verified/verified.component';
import { PostingCardComponent } from './verify-cards/posting-card/posting-card.component';
import { GenericCardComponent } from './verify-cards/generic-card/generic-card.component';
import { MobileExploreComponent } from './mobile-explore/mobile-explore.component';
import { ConnectionSuggestionListComponent } from '../connection/connection-suggestion-list/connection-suggestion-list.component';
import { CmeNudgeModalComponent } from '../web-cme/cme-nudge-modal/cme-nudge-modal.component';
import { NudgesComponent } from '../nudges/nudges.component';
import { ProductType33Component } from '../nudges/product-type33/product-type33.component';
import { TopCasesComponent } from './top-cases/top-cases.component';
import { MobBottomMenuComponent } from './mob-bottom-menu/mob-bottom-menu.component';
import { MobileSearchComponent } from '../search/mobile-search/mobile-search.component';
import { DocquityTeleConsultingComponent } from './docquity-tele-consulting/docquity-tele-consulting.component';
import { TeleConsentFormModalComponent } from './tele-consent-form-modal/tele-consent-form-modal.component';
// import { EditorChoiceHighlightsComponent } from './../editor-choice/editor-choice-highlights/editor-choice-highlights.component';
// import { EditorChoiceCardComponent } from './../editor-choice/editor-choice-card/editor-choice-card.component';

/**
 * Module imports.
 */
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DirectivesModule } from '../directives/directives.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
// import { AgmCoreModule } from '@agm/core';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { CarouselModule, WavesModule } from 'angular-bootstrap-md';
import { CarouselModule as CarouselModulenew } from 'ngx-owl-carousel-o';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { TextFieldModule } from '@angular/cdk/text-field';
import { ReactiveFormsModule } from '@angular/forms';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { SearchingModule } from './searching/searching.module';
import { UserProfilePicModule } from './user-pofile-pic/user-profile-pic.module';
import { CustomTooltipModule } from './custom-tooltip/custom-tooltip.module';
import { ProductLikeModule } from './product-like/product-like.module';
import { ProductBookmarkModule } from './product-bookmark/product-bookmark.module';
import { CommonSuggestionModule } from './common-suggestion/common-suggestion.module';
import { InfoModalModule } from './info-modal/info-modal.module';
import { ConnectionCardModule } from '../connection/connection-card/connection-card.module';
import { ActionModalModule } from './action-modal/action-modal.module';
import { CalenderEventModule } from './calender-event/calender-event.module';
import { ConnectionRequestListModule } from '../connection/connection-request-list/connection-request-list.module';
import { WebCmeCardModule } from '../web-cme/web-cme-card/web-cme-card.module';
import { ConnectionSuggFilterModule } from '../connection/connection-sugg-filter/connection-sugg-filter.module';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { AppBootstrapModule } from '../app-bootstrap/app-bootstrap.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PipesModule } from '../pipes/pipes.module';
import { EditorChoiceModule } from './../editor-choice/editor-choice.module';

/**
 * Module import.
 */
import { AnalyticsEventModule } from '../analytics-event/analytics-event.module';
import { CreateCommunityCardComponent } from './create-community-card/create-community-card.component';
import { CommunityCardComponent } from './community-card/community-card.component';
import { CommunityListComponent } from './community-list/community-list.component';
import { SearchFilterComponent } from '../search/search-list/search-filter/search-filter.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { CounterBarComponent } from './counter-bar/counter-bar.component';
import { SectionComponent } from './section/section.component';
import { RatingsComponent } from './ratings/ratings.component';
import { MultiChoiceGridComponent } from './multi-choice-grid/multi-choice-grid.component';
import { BasicInfoCardComponent } from './basic-info-card/basic-info-card.component';
import { ContentCardModule } from './content-card/content-card.module';
import { ConfirmCardComponent } from './confirm-card/confirm-card.component';
import { ActionPopUpComponent } from './action-pop-up/action-pop-up.component';
import { MultiSelectCheckboxComponent } from './multi-select-checkbox/multi-select-checkbox.component';
import { MultiSelectRadioComponent } from './multi-select-radio/multi-select-radio.component';
import { ConstantSumComponent } from './constant-sum/constant-sum.component';
import { RankingComponent } from './ranking/ranking.component';
import { MultiselectDdlModule } from '../onboarding/multiselect-ddl/multiselect-ddl.module';
import { InputChoiceGridComponent } from './input-choice-grid/input-choice-grid.component';
import { DatePickerModule } from './calender/datepicker/date-picker.module';

@NgModule({
  declarations: [
    ProfileLeftComponent,
    SuggestionRightComponent,
    // ErrorComponent,
    CommentTextComponent,
    ReplyCommentTextComponent,
    PageErrorReloadComponent,
    CommonComponent,
    VerifyProcessComponent,
    PostProcessingComponent,
    NotVerifiedComponent,
    MapAssociationComponent,
    VerificationUnderProcessComponent,
    VerifiedComponent,
    PostingCardComponent,
    GenericCardComponent,
    MobileExploreComponent,
    ConnectionSuggestionListComponent,
    CmeNudgeModalComponent,
    NudgesComponent, ProductType33Component,
    TopCasesComponent,
    // IncompleteProfileComponent,
    MobBottomMenuComponent,
    MobileSearchComponent,
    DocquityTeleConsultingComponent,
    TeleConsentFormModalComponent,
    CreateCommunityCardComponent,
    CommunityCardComponent,
    CommunityListComponent,
    SearchFilterComponent,
    BreadcrumbComponent,
    CounterBarComponent,
    SectionComponent,
    RatingsComponent,
    MultiChoiceGridComponent,
    BasicInfoCardComponent,
    ConfirmCardComponent,
    ActionPopUpComponent,
    MultiSelectCheckboxComponent,
    MultiSelectRadioComponent,
    ConstantSumComponent,
    RankingComponent,
    ConfirmCardComponent,
    InputChoiceGridComponent
  ],
  imports: [
    // NgxDocViewerModule,
    ReactiveFormsModule,
    NgbModalModule,
    TooltipModule.forRoot(),
    CommonModule,
    AppBootstrapModule,
    InfiniteScrollModule,
    PipesModule,
    FormsModule,
    DirectivesModule,
    AngularMultiSelectModule,
    PdfViewerModule,
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyDEPRccIiyh_9H2qon_H9WSMcrOyQWJu1I'
    // }),
    PerfectScrollbarModule,
    CarouselModule, WavesModule,
    CarouselModulenew,
    TextFieldModule,
    VirtualScrollerModule,
    SearchingModule,
    UserProfilePicModule,
    CustomTooltipModule,
    ProductLikeModule, // News Card
    ProductBookmarkModule, // News Card
    CommonSuggestionModule, // Cme-nudge modal
    InfoModalModule,
    ConnectionCardModule,
    ActionModalModule,
    CalenderEventModule,
    ConnectionRequestListModule,
    WebCmeCardModule,
    ConnectionSuggFilterModule,
    AnalyticsEventModule,
    RouterModule,
    EditorChoiceModule,
    ContentCardModule,
    MultiselectDdlModule,
    ContentCardModule,
    DatePickerModule,
  ],
  exports: [
    NgbModalModule,
    DirectivesModule,
    ProfileLeftComponent,
    SuggestionRightComponent,
    InfiniteScrollModule,
    PdfViewerModule,
    PageErrorReloadComponent,
    PerfectScrollbarModule,
    CarouselModule, WavesModule,
    VerifyProcessComponent,
    PostProcessingComponent,
    NotVerifiedComponent,
    PostingCardComponent,
    AngularMultiSelectModule,
    CarouselModulenew,
    TextFieldModule,
    ConnectionSuggestionListComponent,
    CmeNudgeModalComponent,
    NudgesComponent,
    ProductType33Component,
    TopCasesComponent,
    MobileExploreComponent,
    MobileSearchComponent,
    VirtualScrollerModule,
    AppBootstrapModule,
    CreateCommunityCardComponent,
    CommunityCardComponent,
    CommunityListComponent,
    SearchFilterComponent,
    BreadcrumbComponent,
    EditorChoiceModule,
    CounterBarComponent,
    SectionComponent,
    RatingsComponent,
    MultiChoiceGridComponent,
    BasicInfoCardComponent,
    ConfirmCardComponent,
    ContentCardModule,
    ActionPopUpComponent,
    MultiSelectRadioComponent,
    MultiSelectCheckboxComponent,
    ConstantSumComponent,
    RankingComponent,
    ContentCardModule,
    InputChoiceGridComponent
  ],
})
export class ShareModule { }
